






















import { Switch } from 'ant-design-vue'
import { Component, Emit, Mixins } from 'vue-property-decorator'

import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput } from '../../mixins'
import { FieldData } from '../../types'

@Component({
  components: {
    FieldWrapper,
  },
})
export default class SwitchInput extends Mixins(BaseInput) {
  @Emit('change')
  change(checked: boolean, event: Event): { checked: boolean, event: Event } {
    return { checked, event }
  }

  get switchSettings(): FieldData & Switch {
    return this.settings as FieldData & Switch
  }

  get size(): 'small' | 'default' | 'large' {
    if (this.switchSettings.size) {
      return this.switchSettings.size
    }
    return 'default'
  }

  get loading(): boolean {
    if (this.switchSettings.loading) {
      return this.switchSettings.loading
    }
    return false
  }
}
